// extracted by mini-css-extract-plugin
module.exports = {"otpCode":"otp-form_otpCode__3GYe1","submit":"otp-form_submit__85JSG","messageError":"otp-form_messageError__3zy38","otpInput":"otp-form_otpInput__3gBVa"};